import React from 'react';

import {
  ErrorText,
  ErrorHeader,
  ActionButton,
  ErrorContainer,
  ErrorHeaderSmall,
  ErrorMessageWrapper,
} from './response-error.styled';

const FormViewExceededError = () => {
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <p id="exclaim">Oops!</p>
        <ErrorHeader>We are sorry, this form is not available because the form view has been exceeded</ErrorHeader>

        <ErrorHeaderSmall>Want to create your own forms?</ErrorHeaderSmall>
        <ErrorText>
          <p>You can explore all Formplus features for free.</p>
        </ErrorText>
        <ActionButton href="/?utm_source=forms&utm_medium=archivedforms&utm_campaign=archived%20forms%20CTA">
          Get Started
        </ActionButton>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default FormViewExceededError;
